// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"507":"65f646be","639":"493fdac3"}[chunkId] + ".chunk.css";
};